import Model from './Model'
import ReportField from './ReportField'

export default class ReportPart extends Model {
  id: number
  title: string
  note: string
  dropoffNote: string
  section: number
  supports = []
  checklists = []
  infos = []
  notes = []

  canImportItems: boolean
  isItemPart: boolean

  constructor(json, locale) {
    super({})
    this.id = json.id
    this.title = this.translateField(json._title, locale)
    this.note = json.note
    this.dropoffNote = json.dropoff_note
    this.section = json.position

    this.infos = json.infos ? json.infos
      .map((field) => new ReportField(field, locale)) : []

    this.checklists = json.checklists ? json.checklists
      .map((field) => new ReportField(field, locale)) : []

    this.supports = json.supports ? json.supports
      .map((field) => new ReportField(field, locale)) : []

    this.notes = [ new ReportField({
      type: 'note',
      name: '_note',
      value: this.note,
      dropoffValue: this.dropoffNote,
      dropoff: true,
      required: false
    }, locale) ]

    this.isItemPart = json.item || false
    this.canImportItems = json.item
  }
}
